export default __webpack_public_path__ + "static/media/flag-small-icon.f1e8f9e9.svg";